module.exports = __webpack_public_path__ + "img/round2-option2.1a380e95.png";